/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/maintenanceMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Maintenance. */
export class Maintenance {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Maintenance.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves maintenance statuses for all features
   * @summary Retrieves maintenance status summary.
   * @param [options] The optional parameters
   * @returns Promise<Models.MaintenanceGetMaintenanceStatusResponse>
   */
  getMaintenanceStatus(options?: coreHttp.RequestOptionsBase): Promise<Models.MaintenanceGetMaintenanceStatusResponse>;
  /**
   * @param callback The callback
   */
  getMaintenanceStatus(callback: coreHttp.ServiceCallback<Models.MaintenanceStatus>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getMaintenanceStatus(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.MaintenanceStatus>): void;
  getMaintenanceStatus(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.MaintenanceStatus>, callback?: coreHttp.ServiceCallback<Models.MaintenanceStatus>): Promise<Models.MaintenanceGetMaintenanceStatusResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getMaintenanceStatusOperationSpec,
      callback) as Promise<Models.MaintenanceGetMaintenanceStatusResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getMaintenanceStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/Maintenance",
  responses: {
    200: {
      bodyMapper: Mappers.MaintenanceStatus
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
